import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as aboutActions from '../../actions/AboutActions';
import * as menuActions from '../../actions/MenuActions';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import Layout from '../../components/Layout/Layout';
import classes from './About.css';

class About extends Component {
    componentDidMount() {
        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();
            this.props.showLeftMenu();
        });

        this.props.getBiography();
    }

    render() {
        const { about } = this.props;

        const imageOrigin = `${
            process.env.REACT_APP_API_URL
        }/api/containers/files/download/`;

        const imageURL =
            about.image.length > 0 ? imageOrigin + about.image[0].name : '';

        return (
            <Layout {...this.props.location}>
                <Helmet>
                    <title>Benito Santos - México</title>
                </Helmet>
                <article className="container">
                    <div className="row justify-content-center">
                        <header
                            className={['col-11 col-md-8', classes.Header].join(
                                ' '
                            )}
                        >
                            <img
                                className={classes.Logo}
                                src={BSMLogo}
                                alt="Benito Santos - México"
                            />
                            <img
                                className={classes.BioPicture}
                                src={imageURL}
                                alt="Benito Santos"
                            />
                            <div className={classes.BioName}>{about.name}</div>
                        </header>

                        <div
                            className={[
                                'col-12 col-md-10',
                                classes.BioText
                            ].join(' ')}
                            dangerouslySetInnerHTML={{ __html: about.bio }}
                        />
                    </div>
                </article>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        about: state.about
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions,
            ...aboutActions
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToStore
)(About);



// WEBPACK FOOTER //
// ./src/containers/About/About.js